import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { GTMEvent } from './types/GTMEvent';
import { LiveClassDto } from './types/LiveClassDto';
import { LiveClassEventState } from './types/LiveClassEventState';
import { LiveClassEventType } from './types/LiveClassEventType';
import { ChatBotTrackEvents } from './types/chat-bot-track-events.enum';
import { GtmLiveClassEventDto } from './types/gtm-live-class-event-dto';
import { LCOnboardingTrackEvent } from './types/lc-onboarding-track-event';

declare var window: any;

@Injectable()
export class GTMService {
  sendGA4Event(event?: LCOnboardingTrackEvent | ChatBotTrackEvents | string) {
    try {
      if (!window.dataLayer) {
        window.dataLayer = [];
      }
      window.dataLayer.push({ event: event });
    } catch (e) {
      console.error('Failed sending GTM event: ' + event, e);
    }
  }

  sendEvent(name: GTMEvent, data?: GtmLiveClassEventDto) {
    try {
      if (!window.dataLayer) {
        window.dataLayer = [];
      }
      const event = _.assign(data, { event: name.match(/^gtm./) ? name : 'gtm.' + name });
      window.dataLayer.push(event);
    } catch (e) {
      console.error('Failed sending GTM event: ' + name, data, e);
    }
  }

  sendLiveClassEvent(state: LiveClassEventState, liveClass: LiveClassDto, type?: LiveClassEventType) {
    try {
      this.sendEvent(GTMEvent.LIVE_CLASS_ACTION, {
        state: state,
        liveclassId: liveClass.id,
        liveclassTitle: liveClass.title,
        liveclassType: liveClass.subType,
        liveclassTime: new Date(liveClass.classBegin),
        type: type || LiveClassEventType.USER,
      });
    } catch (e) {
      console.error('Failed sending GTM lc-action event: ' + e);
    }
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/gtm.service.ts